// extracted by mini-css-extract-plugin
module.exports = {"listA":"listA_listA__mQlXD"};